let storageFilterGroup = localStorage.getItem("managernew_filter_group")
  ? localStorage.getItem("managernew_filter_group").split(",")
  : [];
let storageFilterGroupRow = localStorage.getItem("managernew_filter_grouprow")
  ? localStorage.getItem("managernew_filter_grouprow").split(",")
  : [];
let storageFilterStatus = localStorage.getItem("managernew_filter_status")
  ? localStorage.getItem("managernew_filter_status").split(",")
  : [];
let storageFilterService = localStorage.getItem("managernew_filter_service")
  ? localStorage.getItem("managernew_filter_service").split(",")
  : [];
let storageFilterChannel = localStorage.getItem("managernew_filter_channel")
  ? localStorage.getItem("managernew_filter_channel").split(",")
  : [];

storageFilterStatus = storageFilterStatus
  ? storageFilterStatus.map((storage) => parseInt(storage))
  : [];
storageFilterChannel = storageFilterChannel
  ? storageFilterChannel.map((storage) => parseInt(storage))
  : [];
storageFilterGroup = storageFilterGroup
  ? storageFilterGroup.map((storage) => parseInt(storage))
  : [];
storageFilterGroupRow = storageFilterGroupRow
  ? storageFilterGroupRow.map((storage) => parseInt(storage))
  : [];
storageFilterService = storageFilterService
  ? storageFilterService.map((storage) => parseInt(storage))
  : [];

const totalFilters =
  storageFilterStatus.length +
  storageFilterGroup.length +
  storageFilterGroupRow.length +
  storageFilterService.length +
  storageFilterChannel.length;

const initialState = {
  filter_manager_status: storageFilterStatus,
  filter_manager_group: storageFilterGroup,
  filter_manager_channel: storageFilterChannel,
  filter_manager_service: storageFilterService,
  filter_manager_grouprow: storageFilterGroupRow,
  is_active: totalFilters > 0 ? true : false,
};

const filtersmanager = (state = initialState, action) => {
  switch (action.type) {
    case "FILTRO_MANAGER_STATUS":
      return {
        ...state,
        filter_manager_status: action.post,
        is_active: false,
      };
    case "FILTRO_MANAGER_SERVICE":
      return {
        ...state,
        filter_manager_service: action.post,
        is_active: false,
      };
    case "FILTRO_MANAGER_GROUP":
      return {
        ...state,
        filter_manager_group: action.post,
        is_active: false,
      };
    case "FILTRO_MANAGER_GROUPROW":
      return {
        ...state,
        filter_manager_grouprow: action.post,
        is_active: false,
      };
    case "FILTRO_MANAGER_CHANNEL":
      return {
        ...state,
        filter_manager_channel: action.post,
        is_active: false,
      };
    case "HANDLE_ACTIVE_FILTER":
      return {
        ...state,
        is_active: true,
      };
    case "CLEAR_FILTRO_MANAGER_SERVICE":
      return {
        ...state,
        filter_manager_status: [],
        filter_manager_group: [],
        filter_manager_channel: [],
        filter_manager_service: [],
        filter_manager_grouprow: [],
        is_active: true,
      };
    default:
      return state;
  }
};

export default filtersmanager;
